import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const CircleInfoIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "ck7zjhmkua",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm.533 6c.302-.006.588.124.771.35.184.225.242.52.158.792l-.929 4.105c-.027.1-.005.207.062.289.067.082.17.13.28.13.195 0 .354.15.354.333v.667c0 .185-.159.334-.354.334h-1.924c-.296.001-.576-.129-.756-.35-.18-.223-.24-.511-.16-.78l.898-4.134c.028-.1.005-.207-.062-.288-.067-.082-.17-.13-.28-.13-.195 0-.353-.15-.353-.334v-.65c0-.184.158-.334.353-.334h1.942zm-.283-4c.828 0 1.5.672 1.5 1.5S13.078 9 12.25 9s-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z"
    }
  )),
  /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", { transform: "translate(-28 -271) translate(20 257) translate(0 12) translate(7 1) translate(1 1)" }, /* @__PURE__ */ React.createElement("mask", { id: "80fksytg3b", fill: "#000" }, /* @__PURE__ */ React.createElement("use", { href: "#ck7zjhmkua" })), /* @__PURE__ */ React.createElement("use", { fill: "#000", fillRule: "nonzero", href: "#ck7zjhmkua" }), /* @__PURE__ */ React.createElement("g", { fill: "#4D5963", mask: "url(#80fksytg3b)" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0H22V22H0z", transform: "translate(1 1)" }))))))))
);

export { CircleInfoIcon as default };
//# sourceMappingURL=CircleInfoIcon.js.map
